import * as React from 'react';
import { Icon } from '@teamsnap/teamsnap-ui';
import EmailAddress from '../../models/email-address';
import './email-info.scss';

export interface Props {
  emailAddress: EmailAddress;
}

const EmailCard: React.FunctionComponent<Props> = ({ emailAddress }) => (
  <div datatest-id="email-address" className="email-container u-flex u-spaceBottomSm">
    <span>
      <Icon name="mail" mods="u-block u-spaceRightSm u-colorGrey" />
    </span>
    <span>
      <a href={`mailto:${emailAddress.email}`}>{emailAddress.email}</a>
    </span>
  </div>
);

export default EmailCard;
